<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Glossary">
<p class="chnum" id="glo"><span class="right_1" epub:type="pagebreak" id="page_xi" title="xi"><a href="#/text/nav#r_glo">G<span class="small">LOSSARY</span></a></span></p>
<p class="noindent"><i>ab im kopp:</i> crazy, crazy in the head</p>
<p class="noindent"><i>ach:</i> oh</p>
<p class="noindent"><i>aenti:</i> aunt</p>
<p class="noindent"><i>Amisch:</i> Amish</p>
<p class="noindent"><i>appeditlich:</i> delicious</p>
<p class="noindent"><i>bruder:</i> brother</p>
<p class="noindent"><i>bu/buwe:</i> boy/boys</p>
<p class="noindent"><i>daag/daags:</i> day/days</p>
<p class="noindent"><i>daed:</i> father</p>
<p class="noindent"><i>danki:</i> thank you</p>
<p class="noindent"><i>dawdi haus:</i> smaller home, attached to or near the main house</p>
<p class="noindent"><i>Dietsch:</i> Amish language</p>
<p class="noindent"><i>dochder:</i> daughter</p>
<p class="noindent"><i>dumm:</i> dumb</p>
<p class="noindent"><i>dummkopf:</i> idiot</p>
<p class="noindent"><i>Englisch:</i> non-Amish</p>
<p class="noindent"><i>familye:</i> family</p>
<p class="noindent"><i>frau:</i> woman, Mrs.</p>
<p class="noindent"><i>garten</i>: garden</p>
<p class="noindent"><i>geh:</i> go</p>
<p class="noindent"><i>grossmutter</i>: grandmother</p>
<p class="noindent"><span class="right_1" epub:type="pagebreak" id="page_xii" title="xii"><i>grossvatter</i>: grandfather</span></p>
<p class="noindent"><i>gut:</i> good</p>
<p class="noindent"><i>gute nacht:</i> good night</p>
<p class="noindent"><i>hallo:</i> hello</p>
<p class="noindent"><i>haus:</i> house</p>
<p class="noindent"><i>hungerich</i>: hungry</p>
<p class="noindent"><i>kaffee:</i> coffee</p>
<p class="noindent"><i>kapp:</i> white hat worn by Amish women</p>
<p class="noindent"><i>kinn/kinner:</i> child/children</p>
<p class="noindent"><i>kumme:</i> come</p>
<p class="noindent"><i>lieb:</i> love</p>
<p class="noindent"><i>maedel:</i> girl/young woman</p>
<p class="noindent"><i>mamm:</i> mom</p>
<p class="noindent"><i>mann:</i> Amish man</p>
<p class="noindent"><i>mei:</i> my</p>
<p class="noindent"><i>morgen:</i> morning</p>
<p class="noindent"><i>mudder/mutter:</i> mother</p>
<p class="noindent"><i>nee:</i> no</p>
<p class="noindent"><i>nix:</i> nothing</p>
<p class="noindent"><i>onkel:</i> uncle</p>
<p class="noindent"><i>perfekt:</i> perfect</p>
<p class="noindent"><i>schee:</i> pretty/handsome</p>
<p class="noindent"><i>schwesters:</i> sisters</p>
<p class="noindent"><i>sehr:</i> very</p>
<p class="noindent"><i>seltsam:</i> weird</p>
<p class="noindent"><i>sohn:</i> son</p>
<p class="noindent"><i>vatter:</i> father</p>
<p class="noindent"><i>ya:</i> yes</p>
<p class="noindent"><i>yer:</i> your</p>
<p class="noindent"><i>yerself:</i> yourself</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780785217367_Glossary.vue?6bf083c4